import React, { ReactElement } from 'react';
import { MemoTemplateWizardPopulator } from '../populator';
import { useTemplateWizardCommunicator } from 'store/inspection/hooks/useTemplateWizardCommunicator';

function TemplateWizardCommunicator(): ReactElement {
  const { createTemplate, updateTemplate, publishTemplate } =
    useTemplateWizardCommunicator();

  return (
    <MemoTemplateWizardPopulator
      submitCreation={createTemplate}
      submitEdition={updateTemplate}
      publish={publishTemplate}
    />
  );
}

export const MemoTemplateWizardCommunicator = React.memo(
  TemplateWizardCommunicator
);
